module.exports = __webpack_public_path__ + "static/media/d7ru.58641ef4.pdf";